import { configureStore } from "@reduxjs/toolkit";
import { reducer as vs_app } from "./app";
import { reducer as depot } from "./depot";
import { reducer as vs_user } from "./user";
import { reducer as map } from "./map";
import { combineAppReducer } from "@dpdgroupuk/ai-app";

const reducers = combineAppReducer({
  vs_app,
  depot,
  vs_user,
  map,
});

const rootReducers = (state, action) => {
  if (action.type === "RESET_APP_STATE") {
    state = {
      app: { isLoading: false },
    };
  }

  return reducers(state, action);
};

export default configureStore({
  reducer: rootReducers,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck: false,
    }),
  devTools: false,
});
